import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../../../../../components/app/icon/button/icon-button';
import { Tooltip } from '../../../../../components/app/tooltip/tooltip';
import { IconUser } from '../../../../../components/app/icons/user';
import { useRootStore } from '../../../../../providers/root-store-provider';

export const HeaderButtonImpersonation: React.FC = () => {
    const { t } = useTranslation();
    const rootStore = useRootStore();

    return rootStore.cookieService.hasJwtImpersonateToken() ? (
        <Tooltip
            content={t('dialogs.common.impersonation')}
            position={'bottom-right'}
            size={'small'}
            arrowPosition={1.6}
        >
            <IconButton size={{ xs: 'xsmall', xl: 'medium' }} icon={<IconUser />} variant={'warning'} />
        </Tooltip>
    ) : null;
};
